// Configuración centralizada para todas las APIs
export const API_CONFIG = {
  BASE_URL: '',
  TIMEOUT: Number(import.meta.env.VITE_API_TIMEOUT) || 10000,

  // Endpoints
  ENDPOINTS: {
    EMPLEADOS: '/empleados',
    VENTAS: '/ventas',
    ANALYTICS: '/analytics',
    AUTH: '/auth',
    USERS: '/users',
    REPORTS: '/reports'
  },

  // Headers por defecto
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },

  // Configuración de retry
  RETRY: {
    ATTEMPTS: 3,
    DELAY: 1000, // ms
    BACKOFF_FACTOR: 2
  }
};

// Configuración específica por entorno
export const getApiConfig = () => {
  const environment = import.meta.env.VITE_APP_ENVIRONMENT || 'development';
  const base_url = import.meta.env.VITE_API_URL || 'http://localhost';
  const port = import.meta.env.VITE_API_PORT || '3000';

  switch (environment) {
    case 'development':
      return {
        ...API_CONFIG,
        BASE_URL: `${base_url}/api`,
        TIMEOUT: 15000
      };

    case 'production':
      return {
        ...API_CONFIG,
        BASE_URL: `${base_url}:${port}`,
        TIMEOUT: 15000
      };

    default:
      return API_CONFIG;
  }
};

// Tipos para manejo de errores
export interface ApiErrorResponse {
  error: {
    message: string;
    code: string;
    details?: any;
  };
  timestamp: string;
  path: string;
}

// Códigos de error comunes
export const ERROR_CODES = {
  NETWORK_ERROR: 'NETWORK_ERROR',
  TIMEOUT: 'TIMEOUT',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  SERVER_ERROR: 'SERVER_ERROR'
} as const;